export default __webpack_public_path__ + "static/media/logo.73e8cc62.svg";